import {connect} from 'react-redux';
import VirtualEntryBowlerList from './VirtualEntryBowlerList.jsx';
import {handleUpdateVirtualEntry, handleRemoveVirtualEntryFromCart} from './actions';
import {
  closeVirtualEntryEditing,
  setBowlerForCartVirtualEntry,
  setBowlerForCartVirtualEntryAlreadyAssigned
} from '../shared/actionTypes';

const mapStateToProps = (state, props) => ({
  virtualEventId: state.registration.shared.cartVirtualEntries.find(x => x.editing)
  ? state.registration.shared.cartVirtualEntries.find(x => x.editing).virtualEventId
  : state.registration.shared.cartVirtualEntries[0].virtualEventId,
  quantity: state.registration.shared.cartVirtualEntries.find(x => x.editing)
  ? state.registration.shared.cartVirtualEntries.find(x => x.editing).quantity
  : state.registration.shared.cartVirtualEntries[0].quantity,
  source: state.registration.shared.cartVirtualBowlers,
  bowlers: state.registration.shared.bowlers,
  virtualBowlers: state.registration.shared.virtualBowlers,
  submitting: state.registration.shared.submittingVirtualBowlers,
  assignedByOtherCaptain: state.registration.shared.assignedByOtherCaptain,
  showCalculatedDivisionToCaptain: state.registration.base.showCalculatedDivisionToCaptain,
  ...props
});

const mapDispatchToProps = dispatch => ({
  onVirtualEntryBowlerChange: (virtualEntryId, bowlerId, assignedByOtherCaptain) => {
    dispatch(setBowlerForCartVirtualEntry(virtualEntryId, bowlerId));
    dispatch(setBowlerForCartVirtualEntryAlreadyAssigned(assignedByOtherCaptain));
  },
  onVirtualEntryRemoveClick: (virtualEventId, bowlerId) =>
    dispatch(handleRemoveVirtualEntryFromCart(virtualEventId, bowlerId)),
  onCancelClick: () => dispatch(closeVirtualEntryEditing()),
  onUpdateClick: virtualEventId => dispatch(handleUpdateVirtualEntry(virtualEventId))
});

export default connect(mapStateToProps, mapDispatchToProps)(VirtualEntryBowlerList);



// WEBPACK FOOTER //
// ./src/features/registration/rostercheckout/CartVirtualEntryBowlerListContainer.jsx